(function () {
  'use strict';
  if (customElements.get('testimonials-slider')) return;
  customElements.define(
    'testimonials-slider',
    class extends HTMLElement {
      constructor() {
        super();
        this.flkty = null;
        this.onResizeCallback = () => this.onResize();
        this.onScrollbarUpdate = () => this.updateScrollbar();
      }

      connectedCallback() {
        this.container = this.closest('[data-section-type="testimonials"]');
        this.slides = this.querySelectorAll('[data-item]');
        this.barRoot = this.container
          ? this.container.querySelector('[data-testimonials-scrollbar]')
          : null;
        this.checkSlideCount();
        this.listen();
      }

      onResize() {
        this.checkSlideCount();
        if (this.flkty !== null) {
          this.flkty.resize();
          if (this.flkty.size.width >= this.flkty.slideableWidth) {
            this.destroySlider();
          } else {
            requestAnimationFrame(() => this.updateScrollbar());
          }
        }
      }

      checkSlideCount() {
        const e = this.slides.length;
        const t = Boolean(e === 2 && window.innerWidth >= theme.sizes.small);
        const i = Boolean(e === 1);
        if (!t && !i) {
          if (this.flkty) {
            if (this.flkty) {
              (this.flkty.isActive || this.initSlider(),
              this.flkty.slideableWidth > this.flkty.size.width
                ? this.initSlider()
                : this.destroySlider());
            }
          } else {
            this.initSlider();
            this.onResize();
          }
          return;
        }
        this.destroySlider();
      }

      initSlider() {
        this.flkty = new window.theme.Flickity(this, {
          cellSelector: '[data-item]',
          prevNextButtons: true,
          pageDots: !this.container.classList.contains('testimonials-with-images'),
          groupCells: true,
          cellAlign: this.dataset.sliderAlignment,
          contain: true,
          adaptiveHeight: false,
          imagesLoaded: true,
          on: {
            ready: () => {
              this.slidesTabIndex();
              requestAnimationFrame(() => {
                this.querySelectorAll('.flickity-button').forEach((btn) => {
                  window.theme.wrap(btn, 'flickity-button-holder');
                });
                if (this.flkty) this.flkty.resize();
                this.updateScrollbar();
              });
            },
            change: () => {
              this.slidesTabIndex();
              this.updateScrollbar();
            },
          },
        });
        if (this.barRoot) {
          this.flkty.on('scroll', this.onScrollbarUpdate);
          this.flkty.on('settle', this.onScrollbarUpdate);
          this.flkty.on('resize', this.onScrollbarUpdate);
        }
        if (this.container.classList.contains('testimonials-with-images')) {
          this.container.classList.add('has-arrows');
        } else if (window.theme.isMobile()) {
          this.container.classList.remove('has-arrows');
        } else {
          this.container.classList.add('has-arrows');
        }
        this.createResizeClass();
      }

      updateScrollbar() {
        const flkty = this.flkty || window.theme.Flickity.data(this);
        if (!this.barRoot || !flkty || !this.classList.contains('flickity-enabled')) return;
        const inner = flkty.size.innerWidth;
        const slideable = flkty.slideableWidth;
        if (!slideable || slideable <= inner) {
          this.barRoot.setAttribute('hidden', '');
          return;
        }
        const slides = flkty.slides;
        if (!slides.length) {
          this.barRoot.setAttribute('hidden', '');
          return;
        }
        const xBegin = -slides[0].target;
        const xEnd = -slides[slides.length - 1].target;
        const xRange = xEnd - xBegin;
        if (!xRange) {
          this.barRoot.setAttribute('hidden', '');
          return;
        }
        this.barRoot.removeAttribute('hidden');
        const thumb = this.barRoot.querySelector('.testimonials-scrollbar__thumb');
        if (!thumb) return;
        const p = Math.min(1, Math.max(0, (flkty.x - xBegin) / xRange));
        const thumbPct = (inner / slideable) * 100;
        const leftPct = p * (100 - thumbPct);
        thumb.style.width = `${thumbPct}%`;
        thumb.style.left = `${leftPct}%`;
      }

      createResizeClass() {
        if (typeof window.theme.Flickity.prototype._createResizeClass === 'function') return;
        window.theme.Flickity.prototype._createResizeClass = function () {
          this.element.classList.add('carousel--resize');
        };
        window.theme.Flickity.createMethods.push('_createResizeClass');
        const resizeOrig = window.theme.Flickity.prototype.resize;
        window.theme.Flickity.prototype.resize = function () {
          this.element.classList.remove('carousel--resize');
          resizeOrig.call(this);
          this.element.classList.add('carousel--resize');
        };
      }

      slidesTabIndex() {
        window.theme.Flickity.data(this).cells.forEach((cell) => {
          let tab = '-1';
          if (cell.element.classList.contains('is-selected')) tab = '0';
          cell.element.querySelectorAll('a, button').forEach((el) => {
            el.setAttribute('tabindex', tab);
          });
        });
      }

      destroySlider() {
        if (!this.classList.contains('flickity-enabled')) return;
        if (this.flkty !== null) {
          if (this.barRoot) {
            this.flkty.off('scroll', this.onScrollbarUpdate);
            this.flkty.off('settle', this.onScrollbarUpdate);
            this.flkty.off('resize', this.onScrollbarUpdate);
            this.barRoot.setAttribute('hidden', '');
          }
          this.querySelectorAll('.flickity-button')?.forEach((btn) => {
            const holder = btn.parentNode;
            if (holder && holder.classList.contains('flickity-button-holder')) {
              holder.parentNode.insertBefore(btn, holder);
              holder.parentNode.removeChild(holder);
            }
          });
          this.flkty.destroy();
        }
        this.container.classList.remove('has-arrows');
      }

      listen() {
        document.addEventListener('theme:resize:width', this.onResizeCallback);
      }

      disconnectedCallback() {
        document.removeEventListener('theme:resize:width', this.onResizeCallback);
      }
    }
  );
})();
